import { observer } from 'mobx-react-lite';
import { Button } from '@cad-arc';
import { useEnabledFeatures } from '../../../common/hooks/enabled-features/use-enabled-features';
import { getUniversalSearchLabel } from '../../../common/helpers/get-usx-labels';
import { useWorkspacePanel } from '../../../panels/hooks/use-workspace-panel';
import { EventPanelTab } from '../components/event-panel-tab';
import { TabBody } from '../../../panels/entity-panels/tabs/tab-body';
import { useExportDexActivityMutation } from './use-export-dex-activity-mutation';
import { useEventMetadataStore } from '../../event-panel-form/event-metadata';
import { useEventDexActivityQuery } from '../../event-state/use-event-dex-activity-query';
import { DexNextActivityTab } from './dex-next-activity-tab';
import { DexActivityTabBodyContent } from './dex-activity-tab-body-content';

export const DexActivityTab = observer(function DexActivityTab() {
    const panel = useWorkspacePanel();
    const eventId = panel.linkedEntityId;
    const eventNumber = useEventMetadataStore().state.metadata?.agencyEventNumber;
    const exportDexActivityMutation = useExportDexActivityMutation();
    const dexActivityQuery = useEventDexActivityQuery({
        eventId,
        queryOptions: { enabled: panel.isFocused },
    });
    const dexActivityTabEntries = dexActivityQuery.data?.dexActivityTabEntries ?? [];
    const { dexNextEnabled, dexActivityExportEnabled: userHasDexActivityExportAbility } =
        useEnabledFeatures();

    if (dexNextEnabled) {
        return <DexNextActivityTab />;
    }

    return (
        <EventPanelTab
            title={`${getUniversalSearchLabel(dexNextEnabled)} Activity`}
            titleTrailingNode={
                userHasDexActivityExportAbility && dexActivityTabEntries.length > 0 ? (
                    <Button
                        leadingVisual="Export"
                        variant="outline"
                        onClick={() => exportDexActivityMutation.mutate({ eventId, eventNumber })}
                    >
                        Export
                    </Button>
                ) : undefined
            }
        >
            <TabBody constrainToParentHeight>
                <DexActivityTabBodyContent
                    entries={dexActivityTabEntries}
                    isInitialLoading={dexActivityQuery.isInitialLoading}
                />
            </TabBody>
        </EventPanelTab>
    );
});
